// extracted by mini-css-extract-plugin
export var footer = "_q3-5";
export var fulfillmentInput = "_q3-0";
export var shipDateInput = "_q3-1";
export var shipmentModal = "_q3-2";
export var shipmentModalContent = "_q3-3";
export var tableContainer = "_q3-4";